import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { storeInventoryApi } from '../services/storeInventoryApi';

export const useUnifiedStoreInventory = (params?: {
  search?: string;
  category?: string;
  includeCustomerSeeds?: boolean;
  pageNumber?: number;
  pageSize?: number;
  batchPageNumber?: number;
  batchPageSize?: number;
}) => {
  return useQuery({
    queryKey: ['unified-store-inventory', params],
    queryFn: () => storeInventoryApi.getUnifiedInventory(params),
    placeholderData: keepPreviousData,
  });
};
